module.exports = __webpack_public_path__ + "img/sms-preview.8b236ad9.png";